import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var WifiAtennaSvg = function WifiAtennaSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.916 3.279c-3.36 3.506-3.36 9.192 0 12.7l-.987 1.029c-3.905-4.075-3.905-10.684 0-14.759zM19.071 2.249c3.905 4.075 3.905 10.683 0 14.759l-.987-1.03c3.36-3.507 3.36-9.193 0-12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.487 7.678a5.1 5.1 0 0 1 1.06-1.654l-.987-1.03a6.6 6.6 0 0 0-1.362 2.127 6.8 6.8 0 0 0 0 5.015 6.6 6.6 0 0 0 1.362 2.127l.986-1.03a5.1 5.1 0 0 1-1.059-1.654 5.3 5.3 0 0 1 0-3.901M16.44 4.995a6.6 6.6 0 0 1 1.362 2.126 6.8 6.8 0 0 1 0 5.015 6.6 6.6 0 0 1-1.362 2.127l-.986-1.03a5.1 5.1 0 0 0 1.059-1.654 5.3 5.3 0 0 0 0-3.901 5.1 5.1 0 0 0-1.06-1.654zM11.302 7.687v14.562h1.396V7.687z"
  }));
};
export var WifiAtenna = function WifiAtenna(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: WifiAtennaSvg
  }));
};